import { createSelector } from '@reduxjs/toolkit';
import { selectCoworkingAccess } from 'shared/selectors/jsonQuery';
import { ECoworkingAccess } from '../../../../packages/JsonQuery/types/coworkingAccess';

const OPTIONS = [
  { label: 'Круглосуточно', value: ECoworkingAccess.AllDayAccess },
  { label: 'В выходные дни', value: ECoworkingAccess.AllWeekAccess },
];

export const selectCoworkingAccessFilter = createSelector(selectCoworkingAccess, value => ({
  label: 'Доступ',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
